module.exports = __webpack_public_path__ + "static/img/cw.9f1c72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cw.png
// module id = dEHR
// module chunks = 0